import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {axiosBaseQuery} from "utils/http"
import {City} from "types/City"
import {PAGINATION_LIMITS} from "../../constants/constants"

interface ResponseCities {
    message: string | null
    status: boolean
    data: {
        content: City[]
        page_number: number
        page_size: number
        total_elements: number
    }
}

interface ResponseSyncCities {
    status: "status" | "error"
}

interface ArgsEditCity {
    id: number
    is_active: boolean
}

interface CitiesRequestParams {
    page: number
    size: number
}

const endpoints = {
    Cities: "cities",
    List: "/list",
    Activation: "/activation",
    Inactivation: "/inactivation",
    Sync: "/branches/sync"
}

export const cityApi = createApi({
    reducerPath: "cityApi",
    baseQuery: axiosBaseQuery(),
    tagTypes: ["city"],
    endpoints: build => ({
        getCities: build.query<ResponseCities, CitiesRequestParams | void>({
            query: args => {
                const {page = 1, size = PAGINATION_LIMITS.TWENTY} = args || {}
                return {
                    url: `${endpoints.Cities}${endpoints.List}`,
                    method: "POST",
                    body: {page, size}
                }
            },
            providesTags: ["city"]
        }),

        syncCities: build.mutation<ResponseSyncCities, void>({
            query: () => ({
                url: `${endpoints.Sync}`,
                method: "POST"
            }),
            invalidatesTags: ["city"]
        }),

        updateCityStatus: build.mutation<void, ArgsEditCity>({
            query: params => {
                const baseEndpoint = `${endpoints.Cities}/${params?.id}`
                const endpoint = params?.is_active ? endpoints.Inactivation : endpoints.Activation
                return {
                    url: `${baseEndpoint}${endpoint}`,
                    method: "PATCH"
                }
            },
            invalidatesTags: ["city"]
        })
    })
})

export const {useGetCitiesQuery, useSyncCitiesMutation, useUpdateCityStatusMutation} = cityApi
